import { render, staticRenderFns } from "./PriceChangeRequestQuickView.vue?vue&type=template&id=701d562b&scoped=true&"
import script from "./PriceChangeRequestQuickView.vue?vue&type=script&lang=js&"
export * from "./PriceChangeRequestQuickView.vue?vue&type=script&lang=js&"
import style0 from "./PriceChangeRequestQuickView.vue?vue&type=style&index=0&id=701d562b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701d562b",
  null
  
)

export default component.exports